var exports = {
  "V": "x61f99309--6dc860--subtitle",
  "g": "x61f99309--6dc860--subtitle__item",
};

module.exports = exports;
